import { defineStore } from 'pinia'

// Login-screen draft state. This is the ONLY persisted Pinia store in the app
// (replacing the previous Vuex/`vuex-persist` setup, Requirement 13.1).
//
// Only the non-sensitive draft of the login form is persisted (the email the
// visitor last typed) so that returning to the hidden Login_Landing_Page
// restores their in-progress entry. The password is intentionally NEVER
// persisted and is held in component state only.
export const useLoginDraftStore = defineStore('loginDraft', {
  state: () => ({
    email: ''
  }),
  actions: {
    setEmail (email) {
      this.email = email
    },
    clear () {
      this.email = ''
    }
  },
  // Scope persistence to this store only, and only persist the email field.
  persist: {
    key: 'ts-login-draft',
    storage: window.localStorage,
    paths: ['email']
  }
})
